import { AttachMoney, Star, Favorite, Label, Savings, Email, People, Article } from '@mui/icons-material';

export const funcionalidades = [
    { icon: <AttachMoney sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Onde você encontra descontos só para você!" },
    { icon: <Star sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Para salvar seus cupons e usá-los a qualquer hora." },
    { icon: <Favorite sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Para escolher suas lojas e categorias favoritas." },
    { icon: <Label sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Fique sempre atualizado com MeuCupom Alerta" }
];

export const servicos = [
    { icon: <Savings sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Um espaço personalizado para divulgar os descontos da sua marca." },
    { icon: <Email sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Promover seus descontos com nossa base segmentada e atrair novos clientes." },
    { icon: <People sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Ampliar a exposição de suas ofertas e interagir através de nossas redes sociais." },
    { icon: <Article sx={{ color: "var(--c-brand-accent-bright)" }} />, text: "Exiba seus descontos em nosso blog e também nos artigos de nossos blogs parceiros." }
];
